<input type="checkbox" (click)="checkedHandler($event)" [checked]="params.value" />